<template>
  <div class="page gallery">
    <div class="container">
      <h1 class="page-title">Galeria</h1>
      <image-gallery />
    </div>
  </div>
</template>
<script>
import ImageGallery from "../components/ImageGallery";

export default {
  components: {
    ImageGallery,
  },
};
</script>
<style lang="scss">
.gallery {
  @include respond(tab-port) {
    padding-left: 5%;
    padding-right: 5%;
  }

  &__items {
    margin-top: 5rem;
    margin-bottom: 10rem;
  }

  &__row {
    display: flex;
    flex-wrap: wrap;
    padding: 0 4px;
  }

  &__col {
    flex: 25%;
    max-width: 25%;
    padding: 0 4px;

    @include respond(tab-port) {
      flex: 50%;
      max-width: 50%;
    }

    @include respond(phone) {
      flex: 100%;
      max-width: 100%;
    }
  }

  &__image-container {
    margin-top: 8px;
    width: 100%;
    vertical-align: middle;

    &--loading {
      position: relative;
      height: 10rem;
      &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border: 6px dashed $color-wine;
        height: 8rem;
        width: 8rem;
        border-radius: 50%;
        display: block;
        animation: spin 2s linear infinite;
      }
    }
  }

  &__image {
    width: 100%;
    cursor: pointer;
    opacity: 0;
    transition: opacity 1s;
  }
}
</style>
